import React, { useEffect, useState } from "react";
import { Box, Card, CardContent, Grid, IconButton, styled, Tooltip, Typography } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import { AccountCircle, Business } from '@mui/icons-material';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { useNavigate } from "react-router-dom";
import { LoadingPage } from "../../common/LoadingPage";
import { showNotification } from "../../common/Notification/ToastifyNotification";
import { apiRequest } from "../../common/common";
import { useSelector } from "react-redux";

const DemoBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 10
}));

const PlatFormBox = styled(Box)(({ theme }) => ({
  marginTop: 20,
}));

const DividerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  padding: theme.spacing(0, 1),
  minHeight: 50
}));

// const DemoPaper1 = styled(Paper)(({ theme }) => ({
//   borderRadius: '10px',
//   overflow: 'hidden',
//   boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
//   transition: 'transform 0.3s'
// }));

// const DemoBox3 = styled(Box)(({ theme }) => ({
//   padding: '20px', backgroundColor: '#f9f9f9'
// }));

// const DemoTypo = styled(Typography)(({ theme }) => ({
//   fontWeight: 'bold', marginBottom: '10px'
// }));

// const DemoBox4 = styled(Box)(({ theme }) => ({
//   display: 'flex', justifyContent: 'center', padding: 10
// }));

const StatCard = styled(Card)(({ theme }) => ({
  minHeight: 200,
  backgroundColor: theme.palette.background.paper,
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
  borderRadius: '16px',
  transition: 'transform 0.3s ease-in-out',
  '&:hover': {
    transform: 'translateY(-10px)',
  },
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
}));

const StatIcon = styled('div')(({ theme, color }) => ({
  backgroundColor: color || theme.palette.primary.main,
  padding: '15px',
  borderRadius: '50%',
  color: 'white',
  marginTop: '20px',
  marginBottom: '5px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: '2rem',
}));

export default function Dashboard() {
  const { user, roles } = useSelector((state) => state.users);
  const isUser = roles.find((a) => a.id === user?.role_id);
  const currentPlanId = user?.organization?.Subscriptions[0]?.plan_id;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [platForm, setPlatForm] = useState(null);

  const getMatricData = async () => {
    setLoading(true);
    try {
      const response = await apiRequest('get', '/org-admin/platform-metrics');
      setPlatForm(response.data.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      showNotification(error?.response?.data.error || error.message, 'error');
    }
  }

  useEffect(() => {
    getMatricData();
    localStorage.removeItem('projectData');
    localStorage.removeItem('itemData');
  }, []);

  return (
    <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
      <DividerHeader />
      {loading && (<LoadingPage isLoading={loading} />)}
      <DemoBox onClick={() => navigate('/app/projects/create')}>
        <Typography variant='h4' style={{ fontWeight: 'bold' }}>Home</Typography>
        {(currentPlanId !== 7 && isUser?.code !== 'orgGuestUser') && (
          <Tooltip title="Create Project">
            <IconButton style={{ background: 'lightgray' }}>
              <AddIcon color="primary" />
            </IconButton>
          </Tooltip>
        )}
      </DemoBox>
      <PlatFormBox>
        <Typography variant='body1' style={{ fontWeight: 'bold' }}>Platform matrics</Typography>
        <Grid container spacing={4} justifyContent="center">
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <StatCard>
              <StatIcon color="#FF9800">
                <AccountCircle fontSize="large" />
              </StatIcon>
              <CardContent>
                <Typography variant="h5" color="textSecondary" gutterBottom>
                  Users
                </Typography>
                <Typography variant="h4" color="textPrimary">
                  {platForm?.user_count}
                </Typography>
              </CardContent>
            </StatCard>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <StatCard>
              <StatIcon color="#4CAF50">
                <Business fontSize="large" />
              </StatIcon>
              <CardContent>
                <Typography variant="h5" color="textSecondary" gutterBottom>
                  Organizations
                </Typography>
                <Typography variant="h4" color="textPrimary">
                  {platForm?.organization_count}
                </Typography>
              </CardContent>
            </StatCard>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <StatCard>
              <StatIcon color="#2196F3">
                <LocalOfferIcon fontSize="large" />
              </StatIcon>
              <CardContent>
                <Typography variant="h5" color="textSecondary" gutterBottom>
                  Products
                </Typography>
                <Typography variant="h4" color="textPrimary">
                  {platForm?.product_count}
                </Typography>
              </CardContent>
            </StatCard>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <StatCard>
              <StatIcon color="#9C27B0">
                <FileCopyIcon fontSize="large" />
              </StatIcon>
              <CardContent>
                <Typography variant="h5" color="textSecondary" gutterBottom>
                  Resources
                </Typography>
                <Typography variant="h4" color="textPrimary">
                  {platForm?.resource_count}
                </Typography>
              </CardContent>
            </StatCard>
          </Grid>
        </Grid>
      </PlatFormBox>
      {/* <PlatFormBox>
        <Typography variant='body1' style={{ fontWeight: 'bold' }}>Blogs</Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={3}>
            <DemoPaper1>
              <DemoBox3>
                <DemoTypo variant="body2">Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.</DemoTypo>
              </DemoBox3>
              <DemoBox4>
                <img src="/images/dummy.png" alt="blog img" style={{ width: '100%', height: '200px', objectFit: 'cover' }} />
              </DemoBox4>
            </DemoPaper1>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <DemoPaper1>
              <DemoBox3>
                <DemoTypo variant="body2">Consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna</DemoTypo>
              </DemoBox3>
              <DemoBox4>
                <img src="/images/dummy.png" alt="blog img" style={{ width: '100%', height: '200px', objectFit: 'cover' }} />
              </DemoBox4>
            </DemoPaper1>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <DemoPaper1>
              <DemoBox3>
                <DemoTypo variant="body2">Lorem ipsum dolor sit amet, consectetuer adipiscing elit.</DemoTypo>
              </DemoBox3>
              <DemoBox4>
                <img src="/images/dummy.png" alt="blog img" style={{ width: '100%', height: '200px', objectFit: 'cover' }} />
              </DemoBox4>
            </DemoPaper1>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <DemoPaper1>
              <DemoBox3>
                <DemoTypo variant="body2">Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.</DemoTypo>
              </DemoBox3>
              <DemoBox4>
                <img src="/images/dummy.png" alt="blog img" style={{ width: '100%', height: '200px', objectFit: 'cover' }} />
              </DemoBox4>
            </DemoPaper1>
          </Grid>
        </Grid>
      </PlatFormBox> */}
    </Box>
  )
}